/* import __COLOCATED_TEMPLATE__ from './footer.hbs'; */
/**

 ## Card Footer

 The `sq-card/footer` component is designed to be used as a contextual component in: [sq-card](/components/glass/sq-card.html).

 This component yields the contextual components `button`, `button-primary`, and `button-secondary`,
 which are all instances of [`sq-button`](/components/glass/sq-button.html).
 **/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['card__footer']
});